import { render, staticRenderFns } from "./curriculumSetting.vue?vue&type=template&id=f752e334&scoped=true"
import script from "./curriculumSetting.vue?vue&type=script&lang=js"
export * from "./curriculumSetting.vue?vue&type=script&lang=js"
import style0 from "./curriculumSetting.vue?vue&type=style&index=0&id=f752e334&prod&scoped=true&lang=scss"
import style1 from "./curriculumSetting.vue?vue&type=style&index=1&id=f752e334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f752e334",
  null
  
)

export default component.exports